"use client"
import { ChevronsLeft, MoreHorizontal } from "@/assets/icons"
import { useRouter } from "next/navigation"
import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"

type ButtonProps = ComponentProps<'button'>

export function Button(props: ButtonProps) {
    return (
        <button {...props}
            className={twMerge(
                `cursor-pointer disabled:opacity-75 disabled:pointer-events-none flex gap-2 
                items-center justify-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent`,
                props.className)} />
    )
}

export function MoreButton(props: ButtonProps) {
    return (
        <button className="cursor-pointer border border-ochre_accent rounded-md" {...props}>
            <MoreHorizontal />
        </button>
    )
}

export function ColorButton(props: ButtonProps) {
    return (
        <button {...props}
            className={twMerge(`
                flex py-2 px-3 bg-ochre_accent text-dark_primary items-center justify-center rounded-sm border-2 border-light_secondary
            hover:scale-105 hover:text-light_accent dark:border-dark_secondary cursor-pointer
            disabled:bg-light_secondary disabled:opacity-75 disabled:pointer-events-none
            dark:disabled:bg-dark_secondary dark:disabled:text-light_primary dark:disabled:border-dark_accent`,
                props.className)} />
    )
}

export function ComebackButton(props: ButtonProps) {
    const router = useRouter()
    return (
        <button {...props}
            onClick={() => setTimeout(() => { router.back(); }, 1000)}
            className={twMerge(`flex mt-3 py-2 px-3 bg-ochre_accent text-dark_primary items-center justify-center rounded border-2 border-light_secondary
            hover:scale-105 hover:text-light_accent dark:border-dark_secondary 
            disabled:bg-light_secondary disabled:opacity-75 disabled:pointer-events-none
            dark:disabled:bg-dark_secondary dark:disabled:text-light_primary dark:disabled:border-dark_accent`,
                props.className)} >
            <ChevronsLeft className="size-7" /> Voltar
        </button>
    )
}

